import { MaskedChars } from "@/components/motion/Reveal";
import ScrambleText from "@/components/motion/ScrambleText";

export default function PageHeader({ eyebrow, titleLines, intro }) {
  return (
    <section className="relative overflow-hidden border-b border-line pt-28 sm:pt-32 md:pt-36 lg:pt-44">
      <span
        aria-hidden="true"
        className="stroke-ink pointer-events-none absolute -right-8 -top-6 select-none font-display text-[34vw] font-extrabold leading-none opacity-[0.05] md:text-[20vw]"
      >
        #
      </span>
      <div className="relative mx-auto max-w-[1600px] px-5 pb-12 sm:pb-14 md:pb-16 lg:pb-20 sm:px-8 md:px-10 lg:px-12 xl:px-16">
        {eyebrow && (
          <p className="mb-6 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.22em] text-accent">
            <span className="h-px w-10 bg-accent" />
            <ScrambleText text={eyebrow} />
          </p>
        )}
        <MaskedChars
          lines={titleLines}
          className="font-display text-[13vw] font-extrabold leading-[0.9] tracking-tighter text-ink md:text-[7vw]"
        />
        {intro && <p className="mt-8 max-w-2xl text-lg leading-relaxed text-muted">{intro}</p>}
      </div>
    </section>
  );
}
